module.exports = __webpack_public_path__ + "img/digiwatch.10519861.jpg";